import { render, staticRenderFns } from "./LembagaPopup.vue?vue&type=template&id=381b5cd0&scoped=true"
import script from "./LembagaPopup.vue?vue&type=script&lang=js"
export * from "./LembagaPopup.vue?vue&type=script&lang=js"
import style0 from "./LembagaPopup.vue?vue&type=style&index=0&id=381b5cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381b5cd0",
  null
  
)

export default component.exports